// source: io/codedrills/proto/builder/content_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_pb);
var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_view_pb);
goog.exportSymbol('proto.io.codedrills.proto.builder.CreateAttachmentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.CreateAttachmentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.CreateContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.CreateContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.DeleteContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.DeleteContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.ExportProblemRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.ExportProblemResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.GetContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.GetContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.GetMetaDataRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.GetMetaDataResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.GetTestCaseRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.GetTestCaseResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.ListContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.ListContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.PublishContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.PublishContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UpdateContentRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UpdateContentResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UpdateMetaDataRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UpdateMetaDataResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UpdateTestDurationRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UpdateTestDurationResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UploadFile', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UploadFile.ContentCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UploadFileResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UploadMcqCsvRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.builder.UploadMcqCsvResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.CreateContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.CreateContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.CreateContentRequest.displayName = 'proto.io.codedrills.proto.builder.CreateContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.CreateContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.CreateContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.CreateContentResponse.displayName = 'proto.io.codedrills.proto.builder.CreateContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.GetContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.GetContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.GetContentRequest.displayName = 'proto.io.codedrills.proto.builder.GetContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.GetContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.GetContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.GetContentResponse.displayName = 'proto.io.codedrills.proto.builder.GetContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UpdateContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.builder.UpdateContentRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UpdateContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UpdateContentRequest.displayName = 'proto.io.codedrills.proto.builder.UpdateContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UploadFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.builder.UploadFile.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.builder.UploadFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UploadFile.displayName = 'proto.io.codedrills.proto.builder.UploadFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UpdateContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.builder.UpdateContentResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UpdateContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UpdateContentResponse.displayName = 'proto.io.codedrills.proto.builder.UpdateContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UploadFileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UploadFileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UploadFileResponse.displayName = 'proto.io.codedrills.proto.builder.UploadFileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.CreateAttachmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.CreateAttachmentRequest.displayName = 'proto.io.codedrills.proto.builder.CreateAttachmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.CreateAttachmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.CreateAttachmentResponse.displayName = 'proto.io.codedrills.proto.builder.CreateAttachmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.ListContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.ListContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.ListContentRequest.displayName = 'proto.io.codedrills.proto.builder.ListContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.ListContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.builder.ListContentResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.builder.ListContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.ListContentResponse.displayName = 'proto.io.codedrills.proto.builder.ListContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.DeleteContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.DeleteContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.DeleteContentRequest.displayName = 'proto.io.codedrills.proto.builder.DeleteContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.DeleteContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.DeleteContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.DeleteContentResponse.displayName = 'proto.io.codedrills.proto.builder.DeleteContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.PublishContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.PublishContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.PublishContentRequest.displayName = 'proto.io.codedrills.proto.builder.PublishContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.PublishContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.PublishContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.PublishContentResponse.displayName = 'proto.io.codedrills.proto.builder.PublishContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UpdateTestDurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UpdateTestDurationRequest.displayName = 'proto.io.codedrills.proto.builder.UpdateTestDurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UpdateTestDurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UpdateTestDurationResponse.displayName = 'proto.io.codedrills.proto.builder.UpdateTestDurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.ExportProblemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.ExportProblemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.ExportProblemRequest.displayName = 'proto.io.codedrills.proto.builder.ExportProblemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.ExportProblemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.ExportProblemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.ExportProblemResponse.displayName = 'proto.io.codedrills.proto.builder.ExportProblemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.GetTestCaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.GetTestCaseRequest.displayName = 'proto.io.codedrills.proto.builder.GetTestCaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.GetTestCaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.GetTestCaseResponse.displayName = 'proto.io.codedrills.proto.builder.GetTestCaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.GetMetaDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.GetMetaDataRequest.displayName = 'proto.io.codedrills.proto.builder.GetMetaDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.GetMetaDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.GetMetaDataResponse.displayName = 'proto.io.codedrills.proto.builder.GetMetaDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UpdateMetaDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UpdateMetaDataRequest.displayName = 'proto.io.codedrills.proto.builder.UpdateMetaDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UpdateMetaDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UpdateMetaDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UpdateMetaDataResponse.displayName = 'proto.io.codedrills.proto.builder.UpdateMetaDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UploadMcqCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UploadMcqCsvRequest.displayName = 'proto.io.codedrills.proto.builder.UploadMcqCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.builder.UploadMcqCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.builder.UploadMcqCsvResponse.displayName = 'proto.io.codedrills.proto.builder.UploadMcqCsvResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.CreateContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.CreateContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    contentJson: jspb.Message.getFieldWithDefault(msg, 3, ""),
    autoPublish: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    customerId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.CreateContentRequest}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.CreateContentRequest;
  return proto.io.codedrills.proto.builder.CreateContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.CreateContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.CreateContentRequest}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentJson(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoPublish(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.CreateContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.CreateContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getContentJson();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAutoPublish();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.CreateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional io.codedrills.proto.content.ContentType type = 2;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.getType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.builder.CreateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string content_json = 3;
 * @return {string}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.getContentJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.CreateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.setContentJson = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool auto_publish = 4;
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.getAutoPublish = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.builder.CreateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.setAutoPublish = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 customer_id = 5;
 * @return {number}
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.CreateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateContentRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.CreateContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.CreateContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.CreateContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: (f = msg.getContent()) && io_codedrills_proto_content_content_pb.Content.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.CreateContentResponse}
 */
proto.io.codedrills.proto.builder.CreateContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.CreateContentResponse;
  return proto.io.codedrills.proto.builder.CreateContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.CreateContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.CreateContentResponse}
 */
proto.io.codedrills.proto.builder.CreateContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Content;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Content.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.CreateContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.CreateContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.CreateContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Content.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.Content content = 1;
 * @return {?proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.builder.CreateContentResponse.prototype.getContent = function() {
  return /** @type{?proto.io.codedrills.proto.content.Content} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Content, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.Content|undefined} value
 * @return {!proto.io.codedrills.proto.builder.CreateContentResponse} returns this
*/
proto.io.codedrills.proto.builder.CreateContentResponse.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.CreateContentResponse} returns this
 */
proto.io.codedrills.proto.builder.CreateContentResponse.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.CreateContentResponse.prototype.hasContent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.GetContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.GetContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.GetContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.GetContentRequest}
 */
proto.io.codedrills.proto.builder.GetContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.GetContentRequest;
  return proto.io.codedrills.proto.builder.GetContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.GetContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.GetContentRequest}
 */
proto.io.codedrills.proto.builder.GetContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.GetContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.GetContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.GetContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.builder.GetContentRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.builder.GetContentRequest} returns this
*/
proto.io.codedrills.proto.builder.GetContentRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.GetContentRequest} returns this
 */
proto.io.codedrills.proto.builder.GetContentRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.GetContentRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.GetContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.GetContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: (f = msg.getContent()) && io_codedrills_proto_content_content_pb.Content.toObject(includeInstance, f),
    contentView: (f = msg.getContentView()) && io_codedrills_proto_content_view_pb.ContentView.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.GetContentResponse}
 */
proto.io.codedrills.proto.builder.GetContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.GetContentResponse;
  return proto.io.codedrills.proto.builder.GetContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.GetContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.GetContentResponse}
 */
proto.io.codedrills.proto.builder.GetContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Content;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Content.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_view_pb.ContentView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.ContentView.deserializeBinaryFromReader);
      msg.setContentView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.GetContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.GetContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Content.serializeBinaryToWriter
    );
  }
  f = message.getContentView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_view_pb.ContentView.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.Content content = 1;
 * @return {?proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.getContent = function() {
  return /** @type{?proto.io.codedrills.proto.content.Content} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Content, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.Content|undefined} value
 * @return {!proto.io.codedrills.proto.builder.GetContentResponse} returns this
*/
proto.io.codedrills.proto.builder.GetContentResponse.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.GetContentResponse} returns this
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.hasContent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.ContentView content_view = 2;
 * @return {?proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.getContentView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.ContentView, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentView|undefined} value
 * @return {!proto.io.codedrills.proto.builder.GetContentResponse} returns this
*/
proto.io.codedrills.proto.builder.GetContentResponse.prototype.setContentView = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.GetContentResponse} returns this
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.clearContentView = function() {
  return this.setContentView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.GetContentResponse.prototype.hasContentView = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UpdateContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UpdateContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    version: jspb.Message.getFieldWithDefault(msg, 3, 0),
    data: (f = msg.getData()) && io_codedrills_proto_content_content_pb.Data.toObject(includeInstance, f),
    metaData: (f = msg.getMetaData()) && io_codedrills_proto_content_content_pb.MetaData.toObject(includeInstance, f),
    testFilesList: jspb.Message.toObjectList(msg.getTestFilesList(),
    proto.io.codedrills.proto.builder.UploadFile.toObject, includeInstance),
    publishType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    contentType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    autoPublish: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    customerId: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UpdateContentRequest;
  return proto.io.codedrills.proto.builder.UpdateContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UpdateContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_content_pb.Data;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Data.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 5:
      var value = new io_codedrills_proto_content_content_pb.MetaData;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.MetaData.deserializeBinaryFromReader);
      msg.setMetaData(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.builder.UploadFile;
      reader.readMessage(value,proto.io.codedrills.proto.builder.UploadFile.deserializeBinaryFromReader);
      msg.addTestFiles(value);
      break;
    case 7:
      var value = /** @type {!proto.io.codedrills.proto.content.PublishType} */ (reader.readEnum());
      msg.setPublishType(value);
      break;
    case 8:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoPublish(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UpdateContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UpdateContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_content_pb.Data.serializeBinaryToWriter
    );
  }
  f = message.getMetaData();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      io_codedrills_proto_content_content_pb.MetaData.serializeBinaryToWriter
    );
  }
  f = message.getTestFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.io.codedrills.proto.builder.UploadFile.serializeBinaryToWriter
    );
  }
  f = message.getPublishType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAutoPublish();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 version = 3;
 * @return {number}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional io.codedrills.proto.content.Data data = 4;
 * @return {?proto.io.codedrills.proto.content.Data}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getData = function() {
  return /** @type{?proto.io.codedrills.proto.content.Data} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Data, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.Data|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
*/
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.hasData = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional io.codedrills.proto.content.MetaData meta_data = 5;
 * @return {?proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getMetaData = function() {
  return /** @type{?proto.io.codedrills.proto.content.MetaData} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.MetaData, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.MetaData|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
*/
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setMetaData = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.clearMetaData = function() {
  return this.setMetaData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.hasMetaData = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated UploadFile test_files = 6;
 * @return {!Array<!proto.io.codedrills.proto.builder.UploadFile>}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getTestFilesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.builder.UploadFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.builder.UploadFile, 6));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.builder.UploadFile>} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
*/
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setTestFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.io.codedrills.proto.builder.UploadFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.builder.UploadFile}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.addTestFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.io.codedrills.proto.builder.UploadFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.clearTestFilesList = function() {
  return this.setTestFilesList([]);
};


/**
 * optional io.codedrills.proto.content.PublishType publish_type = 7;
 * @return {!proto.io.codedrills.proto.content.PublishType}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getPublishType = function() {
  return /** @type {!proto.io.codedrills.proto.content.PublishType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.PublishType} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setPublishType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional io.codedrills.proto.content.ContentType content_type = 8;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional bool auto_publish = 9;
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getAutoPublish = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setAutoPublish = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 customer_id = 10;
 * @return {number}
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.builder.UploadFile.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.builder.UploadFile.ContentCase = {
  CONTENT_NOT_SET: 0,
  CONTENT_STRING: 2
};

/**
 * @return {proto.io.codedrills.proto.builder.UploadFile.ContentCase}
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.getContentCase = function() {
  return /** @type {proto.io.codedrills.proto.builder.UploadFile.ContentCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.builder.UploadFile.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UploadFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UploadFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadFile.toObject = function(includeInstance, msg) {
  var f, obj = {
    filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentString: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testsetId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UploadFile}
 */
proto.io.codedrills.proto.builder.UploadFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UploadFile;
  return proto.io.codedrills.proto.builder.UploadFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UploadFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UploadFile}
 */
proto.io.codedrills.proto.builder.UploadFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentString(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestsetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UploadFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UploadFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTestsetId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string filename = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UploadFile} returns this
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content_string = 2;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.getContentString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UploadFile} returns this
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.setContentString = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.builder.UploadFile.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UploadFile} returns this
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.clearContentString = function() {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.builder.UploadFile.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.hasContentString = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string testset_id = 3;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.getTestsetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UploadFile} returns this
 */
proto.io.codedrills.proto.builder.UploadFile.prototype.setTestsetId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UpdateContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UpdateContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: (f = msg.getContent()) && io_codedrills_proto_content_content_pb.Content.toObject(includeInstance, f),
    contentView: (f = msg.getContentView()) && io_codedrills_proto_content_view_pb.ContentView.toObject(includeInstance, f),
    testFilesResponseList: jspb.Message.toObjectList(msg.getTestFilesResponseList(),
    proto.io.codedrills.proto.builder.UploadFileResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UpdateContentResponse;
  return proto.io.codedrills.proto.builder.UpdateContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UpdateContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Content;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Content.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_view_pb.ContentView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.ContentView.deserializeBinaryFromReader);
      msg.setContentView(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.builder.UploadFileResponse;
      reader.readMessage(value,proto.io.codedrills.proto.builder.UploadFileResponse.deserializeBinaryFromReader);
      msg.addTestFilesResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UpdateContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UpdateContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Content.serializeBinaryToWriter
    );
  }
  f = message.getContentView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_view_pb.ContentView.serializeBinaryToWriter
    );
  }
  f = message.getTestFilesResponseList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.builder.UploadFileResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.Content content = 1;
 * @return {?proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.getContent = function() {
  return /** @type{?proto.io.codedrills.proto.content.Content} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Content, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.Content|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse} returns this
*/
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.hasContent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.ContentView content_view = 2;
 * @return {?proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.getContentView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.ContentView, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentView|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse} returns this
*/
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.setContentView = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.clearContentView = function() {
  return this.setContentView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.hasContentView = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated UploadFileResponse test_files_response = 3;
 * @return {!Array<!proto.io.codedrills.proto.builder.UploadFileResponse>}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.getTestFilesResponseList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.builder.UploadFileResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.builder.UploadFileResponse, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.builder.UploadFileResponse>} value
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse} returns this
*/
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.setTestFilesResponseList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.builder.UploadFileResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.builder.UploadFileResponse}
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.addTestFilesResponse = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.builder.UploadFileResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.builder.UpdateContentResponse} returns this
 */
proto.io.codedrills.proto.builder.UpdateContentResponse.prototype.clearTestFilesResponseList = function() {
  return this.setTestFilesResponseList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UploadFileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UploadFileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadFileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    failReason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UploadFileResponse}
 */
proto.io.codedrills.proto.builder.UploadFileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UploadFileResponse;
  return proto.io.codedrills.proto.builder.UploadFileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UploadFileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UploadFileResponse}
 */
proto.io.codedrills.proto.builder.UploadFileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UploadFileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UploadFileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadFileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getFailReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string filename = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UploadFileResponse} returns this
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.builder.UploadFileResponse} returns this
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string fail_reason = 3;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.getFailReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UploadFileResponse} returns this
 */
proto.io.codedrills.proto.builder.UploadFileResponse.prototype.setFailReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.CreateAttachmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentRequest}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.CreateAttachmentRequest;
  return proto.io.codedrills.proto.builder.CreateAttachmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentRequest}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.CreateAttachmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 content_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool is_public = 4;
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bytes data = 5;
 * @return {string}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes data = 5;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentRequest} returns this
 */
proto.io.codedrills.proto.builder.CreateAttachmentRequest.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.CreateAttachmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachment: (f = msg.getAttachment()) && io_codedrills_proto_content_content_pb.Attachment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentResponse}
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.CreateAttachmentResponse;
  return proto.io.codedrills.proto.builder.CreateAttachmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentResponse}
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Attachment;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Attachment.deserializeBinaryFromReader);
      msg.setAttachment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.CreateAttachmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.CreateAttachmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Attachment.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.Attachment attachment = 1;
 * @return {?proto.io.codedrills.proto.content.Attachment}
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.prototype.getAttachment = function() {
  return /** @type{?proto.io.codedrills.proto.content.Attachment} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Attachment, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.Attachment|undefined} value
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentResponse} returns this
*/
proto.io.codedrills.proto.builder.CreateAttachmentResponse.prototype.setAttachment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.CreateAttachmentResponse} returns this
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.prototype.clearAttachment = function() {
  return this.setAttachment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.CreateAttachmentResponse.prototype.hasAttachment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.ListContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.ListContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.ListContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ListContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.ListContentRequest}
 */
proto.io.codedrills.proto.builder.ListContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.ListContentRequest;
  return proto.io.codedrills.proto.builder.ListContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.ListContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.ListContentRequest}
 */
proto.io.codedrills.proto.builder.ListContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.ListContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.ListContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.ListContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ListContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentType content_type = 1;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.builder.ListContentRequest.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.builder.ListContentRequest} returns this
 */
proto.io.codedrills.proto.builder.ListContentRequest.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.builder.ListContentResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.ListContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.ListContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.ListContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ListContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentsList: jspb.Message.toObjectList(msg.getContentsList(),
    io_codedrills_proto_content_content_pb.Content.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.ListContentResponse}
 */
proto.io.codedrills.proto.builder.ListContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.ListContentResponse;
  return proto.io.codedrills.proto.builder.ListContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.ListContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.ListContentResponse}
 */
proto.io.codedrills.proto.builder.ListContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Content;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Content.deserializeBinaryFromReader);
      msg.addContents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.ListContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.ListContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.ListContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ListContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Content.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.Content contents = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.Content>}
 */
proto.io.codedrills.proto.builder.ListContentResponse.prototype.getContentsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.Content>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_content_pb.Content, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.Content>} value
 * @return {!proto.io.codedrills.proto.builder.ListContentResponse} returns this
*/
proto.io.codedrills.proto.builder.ListContentResponse.prototype.setContentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.Content=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.builder.ListContentResponse.prototype.addContents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.Content, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.builder.ListContentResponse} returns this
 */
proto.io.codedrills.proto.builder.ListContentResponse.prototype.clearContentsList = function() {
  return this.setContentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.DeleteContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.DeleteContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.DeleteContentRequest}
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.DeleteContentRequest;
  return proto.io.codedrills.proto.builder.DeleteContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.DeleteContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.DeleteContentRequest}
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.DeleteContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.DeleteContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.builder.DeleteContentRequest} returns this
*/
proto.io.codedrills.proto.builder.DeleteContentRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.DeleteContentRequest} returns this
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.DeleteContentRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.DeleteContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.DeleteContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.DeleteContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.DeleteContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.DeleteContentResponse}
 */
proto.io.codedrills.proto.builder.DeleteContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.DeleteContentResponse;
  return proto.io.codedrills.proto.builder.DeleteContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.DeleteContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.DeleteContentResponse}
 */
proto.io.codedrills.proto.builder.DeleteContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.DeleteContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.DeleteContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.DeleteContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.DeleteContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.PublishContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.PublishContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.PublishContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.PublishContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.PublishContentRequest}
 */
proto.io.codedrills.proto.builder.PublishContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.PublishContentRequest;
  return proto.io.codedrills.proto.builder.PublishContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.PublishContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.PublishContentRequest}
 */
proto.io.codedrills.proto.builder.PublishContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.PublishContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.PublishContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.PublishContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.PublishContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.builder.PublishContentRequest.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.PublishContentRequest} returns this
 */
proto.io.codedrills.proto.builder.PublishContentRequest.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.PublishContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.PublishContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.PublishContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.PublishContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    publishedVersion: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.PublishContentResponse}
 */
proto.io.codedrills.proto.builder.PublishContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.PublishContentResponse;
  return proto.io.codedrills.proto.builder.PublishContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.PublishContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.PublishContentResponse}
 */
proto.io.codedrills.proto.builder.PublishContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPublishedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.PublishContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.PublishContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.PublishContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.PublishContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPublishedVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.builder.PublishContentResponse.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.PublishContentResponse} returns this
 */
proto.io.codedrills.proto.builder.PublishContentResponse.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 published_version = 2;
 * @return {number}
 */
proto.io.codedrills.proto.builder.PublishContentResponse.prototype.getPublishedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.PublishContentResponse} returns this
 */
proto.io.codedrills.proto.builder.PublishContentResponse.prototype.setPublishedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UpdateTestDurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    durationInS: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UpdateTestDurationRequest;
  return proto.io.codedrills.proto.builder.UpdateTestDurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDurationInS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UpdateTestDurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getDurationInS();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} returns this
*/
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 duration_in_s = 2;
 * @return {number}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.getDurationInS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateTestDurationRequest.prototype.setDurationInS = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UpdateTestDurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: (f = msg.getContent()) && io_codedrills_proto_content_content_pb.Content.toObject(includeInstance, f),
    contentView: (f = msg.getContentView()) && io_codedrills_proto_content_view_pb.ContentView.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UpdateTestDurationResponse;
  return proto.io.codedrills.proto.builder.UpdateTestDurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.Content;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.Content.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_view_pb.ContentView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.ContentView.deserializeBinaryFromReader);
      msg.setContentView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UpdateTestDurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.Content.serializeBinaryToWriter
    );
  }
  f = message.getContentView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_view_pb.ContentView.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.Content content = 1;
 * @return {?proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.getContent = function() {
  return /** @type{?proto.io.codedrills.proto.content.Content} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.Content, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.Content|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse} returns this
*/
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse} returns this
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.hasContent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.ContentView content_view = 2;
 * @return {?proto.io.codedrills.proto.content.ContentView}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.getContentView = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.ContentView, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentView|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse} returns this
*/
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.setContentView = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateTestDurationResponse} returns this
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.clearContentView = function() {
  return this.setContentView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateTestDurationResponse.prototype.hasContentView = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.ExportProblemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.ExportProblemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.ExportProblemRequest}
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.ExportProblemRequest;
  return proto.io.codedrills.proto.builder.ExportProblemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.ExportProblemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.ExportProblemRequest}
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.ExportProblemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.ExportProblemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.builder.ExportProblemRequest} returns this
*/
proto.io.codedrills.proto.builder.ExportProblemRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.ExportProblemRequest} returns this
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.ExportProblemRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.ExportProblemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.ExportProblemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentJsonPath: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.ExportProblemResponse}
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.ExportProblemResponse;
  return proto.io.codedrills.proto.builder.ExportProblemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.ExportProblemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.ExportProblemResponse}
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentJsonPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.ExportProblemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.ExportProblemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentJsonPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string content_json_path = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.prototype.getContentJsonPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.ExportProblemResponse} returns this
 */
proto.io.codedrills.proto.builder.ExportProblemResponse.prototype.setContentJsonPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.GetTestCaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    testSet: jspb.Message.getFieldWithDefault(msg, 2, ""),
    testId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseRequest}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.GetTestCaseRequest;
  return proto.io.codedrills.proto.builder.GetTestCaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseRequest}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestSet(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.GetTestCaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getTestSet();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseRequest} returns this
*/
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseRequest} returns this
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string test_set = 2;
 * @return {string}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.getTestSet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseRequest} returns this
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.setTestSet = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 test_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseRequest} returns this
 */
proto.io.codedrills.proto.builder.GetTestCaseRequest.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.GetTestCaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    input: jspb.Message.getFieldWithDefault(msg, 1, ""),
    output: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseResponse}
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.GetTestCaseResponse;
  return proto.io.codedrills.proto.builder.GetTestCaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseResponse}
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInput(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutput(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.GetTestCaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.GetTestCaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInput();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOutput();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string input = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.prototype.getInput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseResponse} returns this
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.prototype.setInput = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string output = 2;
 * @return {string}
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.prototype.getOutput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.GetTestCaseResponse} returns this
 */
proto.io.codedrills.proto.builder.GetTestCaseResponse.prototype.setOutput = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.GetMetaDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataRequest}
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.GetMetaDataRequest;
  return proto.io.codedrills.proto.builder.GetMetaDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataRequest}
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.GetMetaDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataRequest} returns this
*/
proto.io.codedrills.proto.builder.GetMetaDataRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataRequest} returns this
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.GetMetaDataRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.GetMetaDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    metaData: (f = msg.getMetaData()) && io_codedrills_proto_content_content_pb.MetaData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataResponse}
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.GetMetaDataResponse;
  return proto.io.codedrills.proto.builder.GetMetaDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataResponse}
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.MetaData;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.MetaData.deserializeBinaryFromReader);
      msg.setMetaData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.GetMetaDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.GetMetaDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetaData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.MetaData.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.MetaData meta_data = 1;
 * @return {?proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.prototype.getMetaData = function() {
  return /** @type{?proto.io.codedrills.proto.content.MetaData} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.MetaData, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.MetaData|undefined} value
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataResponse} returns this
*/
proto.io.codedrills.proto.builder.GetMetaDataResponse.prototype.setMetaData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.GetMetaDataResponse} returns this
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.prototype.clearMetaData = function() {
  return this.setMetaData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.GetMetaDataResponse.prototype.hasMetaData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UpdateMetaDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    metaData: (f = msg.getMetaData()) && io_codedrills_proto_content_content_pb.MetaData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UpdateMetaDataRequest;
  return proto.io.codedrills.proto.builder.UpdateMetaDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_content_pb.MetaData;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.MetaData.deserializeBinaryFromReader);
      msg.setMetaData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UpdateMetaDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getMetaData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_content_pb.MetaData.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} returns this
*/
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.MetaData meta_data = 2;
 * @return {?proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.getMetaData = function() {
  return /** @type{?proto.io.codedrills.proto.content.MetaData} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.MetaData, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.MetaData|undefined} value
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} returns this
*/
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.setMetaData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataRequest} returns this
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.clearMetaData = function() {
  return this.setMetaData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataRequest.prototype.hasMetaData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UpdateMetaDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateMetaDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataResponse}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UpdateMetaDataResponse;
  return proto.io.codedrills.proto.builder.UpdateMetaDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UpdateMetaDataResponse}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UpdateMetaDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UpdateMetaDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UpdateMetaDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UpdateMetaDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UploadMcqCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    mcqCsv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UploadMcqCsvRequest;
  return proto.io.codedrills.proto.builder.UploadMcqCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMcqCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UploadMcqCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMcqCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string mcq_csv = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.prototype.getMcqCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UploadMcqCsvRequest} returns this
 */
proto.io.codedrills.proto.builder.UploadMcqCsvRequest.prototype.setMcqCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.builder.UploadMcqCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    mcqCsv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.builder.UploadMcqCsvResponse}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.builder.UploadMcqCsvResponse;
  return proto.io.codedrills.proto.builder.UploadMcqCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.builder.UploadMcqCsvResponse}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMcqCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.builder.UploadMcqCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.builder.UploadMcqCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMcqCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string mcq_csv = 1;
 * @return {string}
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.prototype.getMcqCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.builder.UploadMcqCsvResponse} returns this
 */
proto.io.codedrills.proto.builder.UploadMcqCsvResponse.prototype.setMcqCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.io.codedrills.proto.builder);
